import PropTypes from 'prop-types';
import React from 'react';
import {Navbar} from 'reactstrap';
import './ZadostFooter.scss';

const ZadostFooter = ({children}) => (
    <Navbar id="footer" className="zadost-footer" light fixed="bottom">
        <div>
            {children}
        </div>
    </Navbar>
);

ZadostFooter.propTypes = {
    children: PropTypes.node,
};

export default ZadostFooter;
